import React from 'react';
import { Bars3Icon, BellIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

const Header = ({ setSidebarOpen }) => {
  return (
    <header className="fixed top-0 right-0 left-0 lg:left-64 z-50 bg-white border-b border-gray-200">
      <div className="h-16 flex items-center justify-between px-4">
        <div className="flex items-center">
          <button
            onClick={() => setSidebarOpen(true)}
            className="lg:hidden p-2 rounded-md text-gray-500 hover:text-gray-600 hover:bg-gray-100"
          >
            <Bars3Icon className="w-6 h-6" />
          </button>
          <h1 className="ml-4 text-xl font-semibold text-gray-800 lg:hidden">Procureria</h1>
        </div>
        
        <div className="flex items-center space-x-4">
          <div className="hidden md:flex items-center space-x-2">
            <button className="p-2 text-gray-500 hover:text-gray-600 hover:bg-gray-100 rounded-full">
              <BellIcon className="w-6 h-6" />
            </button>
            <button className="p-2 text-gray-500 hover:text-gray-600 hover:bg-gray-100 rounded-full">
              <QuestionMarkCircleIcon className="w-6 h-6" />
            </button>
          </div>
          
          {/* User Profile */}
          <div className="flex items-center space-x-3 border-l pl-3">
            <span className="hidden md:inline text-sm font-medium text-gray-700">Admin User</span>
            <img
              className="h-8 w-8 rounded-full"
              src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
              alt="User profile"
            />
            <button className="text-sm text-gray-700 hover:text-gray-900">
              Logout
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;